var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlinedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 0.333328C3.31325 0.333328 0.333252 3.31333 0.333252 7C0.333252 10.6867 3.31325 13.6667 6.99992 13.6667C10.6866 13.6667 13.6666 10.6867 13.6666 7C13.6666 3.31333 10.6866 0.333328 6.99992 0.333328ZM6.99992 12.3333C4.05325 12.3333 1.66659 9.94666 1.66659 7C1.66659 4.05333 4.05325 1.66666 6.99992 1.66666C9.94659 1.66666 12.3333 4.05333 12.3333 7C12.3333 9.94666 9.94659 12.3333 6.99992 12.3333Z",
    fill: "#243B53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlinedCircle);
export default __webpack_public_path__ + "static/media/outlined-circle.5e9705c8ac93b3020d3718b17b076140.svg";
export { ForwardRef as ReactComponent };